import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { NameList, NameListFilters } from '../models/name-list';

@Injectable()
export class NameListsService {
    private httpHeaders: HttpHeaders;
    private httpParams: HttpParams;

    constructor(private http: HttpClient) {
        this.init();
    }

    init(): void {
        this.httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': environment.apiKey,
            'X-PhiBor-App': environment.phiborApp
        });
        this.httpParams = new HttpParams();
        this.httpParams = this.httpParams.set('fields', 'name,name_laqab,name_kunya,name_ism,name_nasab,name_nisba');
        // this.httpParams = this.httpParams.set('sort', 'name_sort');
        this.httpParams = this.httpParams.set('expand', '__countMss');
    }

    /* Get all copyists */
    getCopyists(filters: NameListFilters = null): Observable<NameList> {
        return this.http.get<NameList>(
            environment.endpoints.de + '/copyists',
            {
                headers: this.httpHeaders,
                params: this.httpParams.set('sort', (filters && filters.orderBy ? filters.orderBy + '_sort,' : '') + 'name_sort')
                    .set('filter', (filters && filters.containsText ? '{"match":{"name": "\u0025' + filters.containsText + '\u0025"}}' : '{}'))
            }
        );
    }

    /* Get all patrons */
    getPatrons(filters: NameListFilters = null): Observable<NameList> {
        return this.http.get<NameList>(
            environment.endpoints.de + '/patrons',
            {
                headers: this.httpHeaders,
                params: this.httpParams.set('sort', (filters && filters.orderBy ? filters.orderBy + '_sort,' : '') + 'name_sort')
                    .set('filter', (filters && filters.containsText ? '{"match":{"name": "\u0025' + filters.containsText + '\u0025"}}' : '{}'))
            }
        );
    }

    /* Get all owners */
    getOwners(filters: NameListFilters = null): Observable<NameList> {
        return this.http.get<NameList>(
            environment.endpoints.de + '/owners',
            {
                headers: this.httpHeaders,
                params: this.httpParams.set('sort', (filters && filters.orderBy ? filters.orderBy + '_sort,' : '') + 'name_sort')
                    .set('filter', (filters && filters.containsText ? '{"match":{"name": "\u0025' + filters.containsText + '\u0025"}}' : '{}'))
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/services/name-lists.service.ts